var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"p-8"},[_c('ContactRequestList',{ref:"contactRequestList",attrs:{"project-id":_vm.projectId}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }